import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../athlete-objectives.css";
import {
  athleteObjectives,
  recuperationBase,
  reposoBase,
  saturationBase,
} from "../constants";
const Step1Objectives = ({
  userValoration,
  userObjectives,
  setFormData,
  formData,
  control,
}) => {
  const habit_goals = userObjectives?.habit_goals || {};
  const cardiovascular_rest_goals =
    userObjectives?.cardiovascular_rest_goals || {};
  const cardiovascular_recovery_goals =
    userObjectives?.cardiovascular_recovery_goals || {};

  const saturation_pressure_goals =
    userObjectives?.saturation_pressure_goals || {};

  const filterReposo = userValoration?.cardiovascular_system?.discipline.find(
    (e) => e.discipline_id == 4 // Reposo 4
  );
  const filterRecuperation =
    userValoration?.cardiovascular_system?.discipline.find(
      (e) => e.discipline_id == 18 // Recuperación 18
    );

  const firstObjectives = athleteObjectives.map((obj) => ({
    ...obj,
    value: habit_goals?.[obj.label] || null,
  }));

  const reposo = reposoBase.map((item) => ({
    ...item,
    value: cardiovascular_rest_goals?.[item.label] || null,
    valorationValue: filterReposo
      ? filterReposo[
          item.label === "resting_hr_avg_goal"
            ? "hr_med"
            : item.label === "resting_hr_max_goal"
            ? "hr_max"
            : "get_rmssd"
        ] || "---"
      : "---",
    controlValue:
      userObjectives?.cardiovascular_rest_goals?.[
        item.label.replace("_goal", "_actual")
      ] || "---",
  }));

  const reposoObjectives = [
    {
      name: "FC. PROM",
      value: cardiovascular_rest_goals?.resting_hr_avg_goal || null,
      label: "resting_hr_avg_goal",
    },
    {
      name: "FC. MAX",
      value: cardiovascular_rest_goals?.resting_hr_max_goal || null,
      label: "resting_hr_max_goal",
    },
    {
      name: "VFC",
      value: cardiovascular_rest_goals?.resting_hrv_goal || null,
      label: "resting_hrv_goal",
    },
    {
      name: "FC. PROM",
      value: filterReposo?.hr_med || null,
      label: "resting_hr_avg_actual",
    },
    {
      name: "FC. MAX",
      value: filterReposo?.hr_max || null,
      label: "resting_hr_max_actual",
    },
    {
      name: "VFC",
      value: filterReposo?.get_rmssd || null,
      label: "resting_hrv_actual",
    },
  ];

  const recuperation = recuperationBase.map((item) => ({
    ...item,
    value: cardiovascular_recovery_goals?.[item.label] || null,
    valorationValue: filterRecuperation
      ? filterRecuperation[
          item.label === "recovery_hr_max_goal"
            ? "hr_max"
            : item.label === "recovery_hr_5min_goal"
            ? "fc_5min"
            : item.label === "recovery_hr_7min_goal"
            ? "fc_7min"
            : "fc_10min"
        ] || "---"
      : "---",
    controlValue:
      userObjectives?.cardiovascular_recovery_goals?.[
        item.label.replace("_goal", "_actual")
      ] || "---",
  }));
  const recuperationObjectives = [
    {
      name: "FC. MAX",
      value: cardiovascular_recovery_goals?.recovery_hr_max_goal || null,
      label: "recovery_hr_max_goal",
    },
    {
      name: "FC. en 5 minutos",
      value: cardiovascular_recovery_goals?.recovery_hr_5min_goal || null,
      label: "recovery_hr_5min_goal",
    },
    {
      name: "FC. en 7 minutos",
      value: cardiovascular_recovery_goals?.recovery_hr_7min_goal || null,
      label: "recovery_hr_7min_goal",
    },
    {
      name: "FC. en 10 minutos",
      value: cardiovascular_recovery_goals?.recovery_hr_10min_goal || null,
      label: "recovery_hr_10min_goal",
    },
    {
      name: "FC. MAX",
      value: filterRecuperation?.hr_max || null,
      label: "recovery_hr_max_actual",
    },
    {
      name: "FC. en 5 minutos",
      value: filterRecuperation?.fc_5min || null,
      label: "recovery_hr_5min_actual",
    },
    {
      name: "FC. en 7 minutos",
      value: filterRecuperation?.fc_7min || null,
      label: "recovery_hr_7min_actual",
    },
    {
      name: "FC. en 10 minutos",
      value: filterRecuperation?.fc_10min || null,
      label: "recovery_hr_10min_actual",
    },
  ];

  const saturation = saturationBase.map((item) => ({
    ...item,
    value: saturation_pressure_goals?.[item.label] || null,
    valorationValue:
      userValoration?.cardiovascular_system?.h_blood_saturation || "---",
    controlValue:
      userObjectives?.saturation_pressure_goals?.[
        item.label.replace("_goal", "_actual")
      ] || "---",
  }));
  // [
  //   {
  //     name: "SAT",
  //     value: saturation_pressure_goals?.oxygen_saturation_goal || null,
  //     label: "oxygen_saturation_goal",
  //     valorationValue:
  //       userValoration?.cardiovascular_system?.h_blood_saturation || "---",
  //   },
  // ];
  const saturationObjectives = [
    {
      name: "SAT",
      value: saturation_pressure_goals?.oxygen_saturation_goal || null,
      label: "oxygen_saturation_goal",
    },
    {
      name: "Sistólica",
      value: saturation_pressure_goals?.blood_pressure_s_goal || null,
      label: "blood_pressure_s_goal",
    },
    {
      name: "Diastólica",
      value: saturation_pressure_goals?.blood_pressure_d_goal || null,
      label: "blood_pressure_d_goal",
    },
    {
      name: "SAT actual",
      value: userValoration?.cardiovascular_system?.h_blood_saturation || null,
      label: "oxygen_saturation_actual",
    },
    {
      name: "Sistólica actual",
      value: userValoration?.cardiovascular_system?.h_blood_pressure_s || null,
      label: "blood_pressure_s_actual",
    },
    {
      name: "Diastólica actual",
      value: userValoration?.cardiovascular_system?.h_blood_pressure_d || null,
      label: "blood_pressure_d_actual",
    },
  ];

  const checkBoxAction = (name, family, label_actual) => {
    const familyObj = { ...(formData?.[family] || {}) };

    if (familyObj.hasOwnProperty(name)) {
      delete familyObj[name];
      delete familyObj[label_actual];
    } else {
      familyObj[name] = formData?.[family]?.[name] || null;
    }

    const updatedFormData = { ...formData };
    if (Object.keys(familyObj).length === 0) {
      delete updatedFormData[family];
    } else {
      updatedFormData[family] = familyObj;
    }

    setFormData(updatedFormData);
  };

  const toggleGoals = (family, formData, setFormData, label) => {
    // Verifica si ya existen todas las propiedades de family en formData
    const allChecked = family.every(
      (item) => formData?.[label] && formData[label].hasOwnProperty(item.label)
    );

    if (allChecked) {
      // Si ya están todos, borra la familia
      setFormData((prev) => {
        const updated = { ...prev };
        delete updated[label];
        return updated;
      });
    } else {
      // Si no están todos, los agrega todos
      const newFamily = {};
      family.forEach((item) => {
        newFamily[item.label] = item?.value || null;
      });
      setFormData((prev) => ({
        ...prev,
        [[label]]: newFamily,
      }));
    }
  };

  return (
    <div className="h-100">
      <div className="d-flex justify-content-between ps-4 pb-2">
        <span className="label-step-objectives">
          1. Objetivos de construcción de hábitos
        </span>
      </div>
      <div
        className="w-100 h-100 d-flex flex-column gap-2"
        style={{ maxHeight: "94%" }}
      >
        <div className="step2-card p-2 w-100" style={{ height: "25%" }}>
          <PerfectScrollbar className=" p-2">
            {firstObjectives.map((item, idx) => (
              <div
                key={idx}
                className="d-flex align-items-center justify-content-between py-2 w-100"
                style={{ gap: "0.5rem" }}
              >
                {/* Columna 1: Checkbox */}
                <div
                  style={{ flex: "0 0 7%" }}
                  className="d-flex align-items-center"
                >
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      name="user"
                      onClick={() =>
                        checkBoxAction(
                          item.label,
                          "habit_goals",
                          item.label_actual,
                          item.value
                        )
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>

                {/* Columna 2: Texto */}
                <div style={{ flex: "1 1 73%", lineHeight: "1" }}>
                  <span className="label-step-objectives">{item.name}</span>
                </div>

                {/* Columna 3: Input */}
                <div style={{ flex: "0 0 15%" }}>
                  <input
                    disabled={
                      !formData?.["habit_goals"]?.hasOwnProperty(item.label)
                    }
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        habit_goals: {
                          ...prev.habit_goals,
                          [item.label]: Number(e.target.value),
                          [item.label_actual]:
                            userObjectives?.habit_goals?.[item.label_actual],
                        },
                      }));
                    }}
                    name={item.label}
                    style={{ width: "100%" }}
                    value={
                      formData?.["habit_goals"]?.[item.label] ||
                      item?.value ||
                      ""
                    }
                    placeholder=""
                    type="number"
                    className="input-corporal"
                  />
                </div>
              </div>
            ))}
          </PerfectScrollbar>
        </div>
        <div className="d-flex justify-content-between ps-4 pb-2">
          <span className="label-step-objectives">
            2. Objetivos cardiovasculares
          </span>
        </div>
        <div className="step2-card  w-100" style={{ height: "25%" }}>
          <PerfectScrollbar className="p-2">
            <div className="d-flex align-items-center justify-content-center py-2 w-100">
              <div
                className="d-flex align-items-center  justify-content-center"
                style={{ width: "7%" }}
              >
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    name="rest"
                    onClick={() =>
                      toggleGoals(
                        reposoObjectives,
                        formData,
                        setFormData,
                        "cardiovascular_rest_goals"
                      )
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div
                className="d-flex align-items-center mx-auto"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba en reposo
                </span>
              </div>
            </div>

            <div className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center">
              <span className="col-4" style={{ textAlign: "right" }}></span>
              <span
                className="col-4"
                style={{ textAlign: "center", fontWeight: "bold" }}
              >
                Valores actuales
              </span>
              <span
                className="col-4"
                style={{ textAlign: "left", fontWeight: "bold" }}
              >
                Valor objetivo
              </span>
            </div>
            {reposo.map((item, idx) => (
              <div
                key={idx}
                className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center"
              >
                <span className="col-4" style={{ textAlign: "right" }}>
                  {item.name}
                </span>
                <span className="col-4" style={{ textAlign: "center" }}>
                  {control ? item.controlValue : item.valorationValue}
                </span>
                <span className="col-4" style={{ textAlign: "left" }}>
                  <input
                    disabled={
                      !formData?.["cardiovascular_rest_goals"]?.hasOwnProperty(
                        item.label
                      )
                    }
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        cardiovascular_rest_goals: {
                          ...prev.cardiovascular_rest_goals,
                          [item.label]: Number(e.target.value),
                        },
                      }));
                    }}
                    name={item.label}
                    style={{ width: "35%" }}
                    value={
                      formData?.["cardiovascular_rest_goals"]?.[item.label] ||
                      item?.value ||
                      ""
                    }
                    type="number"
                    className=" input-corporal my-1"
                  />
                </span>
              </div>
            ))}
          </PerfectScrollbar>
        </div>
        <div className="step2-card w-100" style={{ height: "25%" }}>
          <PerfectScrollbar className="p-2">
            <div className="d-flex align-items-center justify-content-center  py-2 w-100">
              <div
                className="d-flex align-items-center  justify-content-center"
                style={{ width: "7%" }}
              >
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    name="recuperation"
                    onClick={() =>
                      toggleGoals(
                        recuperationObjectives,
                        formData,
                        setFormData,
                        "cardiovascular_recovery_goals"
                      )
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div
                className="d-flex align-items-center mx-auto"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba de recuperación
                </span>
              </div>
            </div>

            <div className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center">
              <span className="col-4" style={{ textAlign: "right" }}></span>
              <span
                className="col-4"
                style={{ textAlign: "center", fontWeight: "bold" }}
              >
                Valores actuales
              </span>
              <span
                className="col-4"
                style={{ textAlign: "left", fontWeight: "bold" }}
              >
                Valor objetivo
              </span>
            </div>
            {recuperation.map((item, idx) => (
              <div
                key={idx}
                className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center"
              >
                <span className="col-4" style={{ textAlign: "right" }}>
                  {item.name}
                </span>
                <span className="col-4" style={{ textAlign: "center" }}>
                  {control ? item.controlValue : item.valorationValue}
                </span>
                <span className="col-4" style={{ textAlign: "left" }}>
                  <input
                    disabled={
                      !formData?.[
                        "cardiovascular_recovery_goals"
                      ]?.hasOwnProperty(item.label)
                    }
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        cardiovascular_recovery_goals: {
                          ...prev.cardiovascular_recovery_goals,
                          [item.label]: Number(e.target.value),
                        },
                      }));
                    }}
                    name={item.label}
                    style={{ width: "35%" }}
                    value={
                      formData?.["cardiovascular_recovery_goals"]?.[
                        item.label
                      ] ||
                      item?.value ||
                      ""
                    }
                    type="number"
                    className=" input-corporal my-1"
                  />
                </span>
              </div>
            ))}
          </PerfectScrollbar>
        </div>
        <div className="step2-card w-100" style={{ height: "25%" }}>
          <PerfectScrollbar className="p-2">
            <div className="d-flex align-items-center justify-content-center py-2 w-100">
              <div
                className="d-flex align-items-center  justify-content-center"
                style={{ width: "7%" }}
              >
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    name="user"
                    onClick={() =>
                      toggleGoals(
                        saturationObjectives,
                        formData,
                        setFormData,
                        "saturation_pressure_goals"
                      )
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div
                className="d-flex align-items-center mx-auto"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Saturación oxigeno / Tensión arterial
                </span>
              </div>
            </div>

            <div className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center">
              <span className="col-4" style={{ textAlign: "right" }}></span>
              <span
                className="col-4"
                style={{ textAlign: "center", fontWeight: "bold" }}
              >
                Valores actuales
              </span>
              <span
                className="col-4"
                style={{ textAlign: "left", fontWeight: "bold" }}
              >
                Valor objetivo
              </span>
            </div>
            {saturation.map((item, idx) => (
              <div
                key={idx}
                className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center"
              >
                <span className="col-4" style={{ textAlign: "right" }}>
                  {item.name}
                </span>
                <span className="col-4" style={{ textAlign: "center" }}>
                  {control ? item.controlValue : item.valorationValue}
                </span>
                <span className="col-4" style={{ textAlign: "left" }}>
                  <input
                    disabled={
                      !formData?.["saturation_pressure_goals"]?.hasOwnProperty(
                        item.label
                      )
                    }
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        saturation_pressure_goals: {
                          ...prev.saturation_pressure_goals,
                          [item.label]: Number(e.target.value),
                        },
                      }));
                    }}
                    name={item.label}
                    style={{ width: "35%" }}
                    value={
                      formData?.["saturation_pressure_goals"]?.[item.label] ||
                      item?.value ||
                      ""
                    }
                    type="number"
                    className=" input-corporal my-1"
                  />
                </span>
              </div>
            ))}
            <div className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-center">
              <span className="col-4" style={{ textAlign: "right" }}>
                Tensión
              </span>
              {control ? (
                <span className="col-4" style={{ textAlign: "center" }}>
                  {userObjectives?.["saturation_pressure_goals"]?.[
                    "blood_pressure_s_actual"
                  ] || "---"}{" "}
                  /{" "}
                  {userObjectives?.["saturation_pressure_goals"]?.[
                    "blood_pressure_d_actual"
                  ] || "---"}
                </span>
              ) : (
                <span className="col-4" style={{ textAlign: "center" }}>
                  {userValoration?.cardiovascular_system?.h_blood_pressure_s ||
                    "---"}{" "}
                  /{" "}
                  {userValoration?.cardiovascular_system?.h_blood_pressure_d ||
                    "---"}
                </span>
              )}
              <span className="col-4" style={{ textAlign: "left" }}>
                <div
                  className="d-flex gap-2 align-items-center input_info_athlete_input"
                  style={{
                    textAlign: "center",
                    maxWidth: "90%",
                  }}
                >
                  <input
                    disabled={
                      !formData?.["saturation_pressure_goals"]?.hasOwnProperty(
                        "blood_pressure_s_goal"
                      )
                    }
                    placeholder="Sistólica"
                    type="number"
                    name="Sistólica"
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        saturation_pressure_goals: {
                          ...prev.saturation_pressure_goals,
                          ["blood_pressure_s_goal"]: Number(e.target.value),
                        },
                      }));
                    }}
                    value={
                      formData?.["saturation_pressure_goals"]?.[
                        "blood_pressure_s_goal"
                      ] ||
                      saturation_pressure_goals?.blood_pressure_s_goal ||
                      ""
                    }
                    className=" input-corporal my-1"
                  />
                  <span className="input_info_athlete_input">/</span>
                  <input
                    disabled={
                      !formData?.["saturation_pressure_goals"]?.hasOwnProperty(
                        "blood_pressure_d_goal"
                      )
                    }
                    placeholder="Diastólica"
                    name="Diastólica"
                    type="number"
                    className=" input-corporal my-1"
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        saturation_pressure_goals: {
                          ...prev.saturation_pressure_goals,
                          ["blood_pressure_d_goal"]: Number(e.target.value),
                        },
                      }));
                    }}
                    value={
                      formData?.["saturation_pressure_goals"]?.[
                        "blood_pressure_d_goal"
                      ] ||
                      saturation_pressure_goals?.blood_pressure_d_goal ||
                      ""
                    }
                  />
                </div>
              </span>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
};

export default Step1Objectives;
